import { API_BASE_URL } from '@/config/serverApiConfig';

import axios from 'axios';
import errorHandler from '@/request/errorHandler';
import successHandler from '@/request/successHandler';

export const login = async ({ loginData }) => {

  const urlAdaptada = API_BASE_URL.replace('/api/', '/cliente01/api/');

  try {
    const response = await fetch(urlAdaptada + `v1/users/login`, {
      //const response = await fetch(urlAdaptada + `v1/users/login?timestamp=${new Date().getTime()}`, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cache
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(loginData), // body data type must match "Content-Type" header
    });

    const { status } = response;
  
    // 🔴 PASO CLAVE: Primero leemos la respuesta como texto plano para ver qué mandó Quarkus
    const textRaw = await response.text();
  
    // Si está vacío, evitamos romper el flujo con .json()
    let data = {};
    if (textRaw) {
      data = JSON.parse(textRaw); // Convertimos manualmente a objeto
      console.log("3. JSON parseado con éxito ===> ", data);
    } else {
      console.warn("⚠️ Ojo: El backend devolvió un 200 pero el Body vino completamente vacío.");
    }
  

    successHandler(
      { data, status },
      {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      }
    );
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};
export const logout = async () => {
  axios.defaults.withCredentials = true;
  try {
    window.localStorage.clear();
    await axios.post(API_BASE_URL + `logout?timestamp=${new Date().getTime()}`);
  } catch (error) {
    return errorHandler(error);
  }
};
